/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {ManageSessionStore} from '@auth/sotre/management-session.store';
import { EXPIRED_MANAGE_TOKEN } from '@core/tokens/expired-manage-token';
import {catchError, Observable, of, throwError} from 'rxjs';

@Injectable()
export class SupportSessionInterceptor implements HttpInterceptor {
  private readonly supportService = inject(ManageSessionStore);
  private readonly expiredErrorKey = inject(EXPIRED_MANAGE_TOKEN);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (this.supportService.isManagementActive()) {
      const headers = request.headers;

      const requestClone = request.clone({
        headers: headers
          .set('X-Manage-Token', this.supportService.sessionToken() || String(1))
      });

      return next.handle(requestClone).pipe(
        catchError((errorResponse) => {
          if (this.expiredErrorKey === errorResponse.error.code) {
            this.supportService.endSessionResponse();
            return of(errorResponse)
          }
          return throwError(() => errorResponse)
        })
      );
    }

    return next.handle(request);
  }

}
